import { useContext } from 'react';
import Overlays from '../overlays/Overlays';
import { StoreContext } from '../StoreProvider';

const Scenes = () => {
    const { customerData } = useContext(StoreContext);
    const { theVideoGramStore } = customerData;

    return (
        <div className="overlays">
            {theVideoGramStore.scenes.map((scene, index) => {
                return (
                    <Overlays
                        key={index}
                        overlays={scene.overlays}
                        timeOffset={scene.timeOffset}
                    />
                )
            })}
        </div>
    )
}

export default Scenes;
